import React, { useState, useEffect } from 'react';
import { View, TouchableOpacity, Animated } from 'react-native';
import CText from './CText';
import CView from './CView';
import CImage from './CImage';
import { RFValue } from '../utilities/customFont';
import { CreateResponsiveStyle, DEVICE_SIZES } from 'rn-responsive-styles'

const textComponentsOpted = [
    <CView>
        <CText.ucltandcItSm>Avail</CText.ucltandcItSm>
        <CText.ucltandcBold>Benefits</CText.ucltandcBold>
    </CView>,
    <CView>
        <CText.ucltandcItSm>Covered</CText.ucltandcItSm>
        <CText.ucltandcItSm>By<CText.ucltandcBold>MAX!</CText.ucltandcBold></CText.ucltandcItSm>
    </CView>
];

export const ProMaxOptedButton = ({ onPress }) => {

    const onPressButton = () => {
        if (typeof onPress !== "undefined") {
            onPress();
        }
    }

    return (
        <TouchableOpacity style={{ ...styles.button }} onPress={() => onPressButton()}>
            <CImage.MpShieldBlueSmallIconPNG />
            <CView style={{ marginLeft: RFValue(5) }}>
                <CText.ucltandcItSm>Covered</CText.ucltandcItSm>
                <CText.ucltandcBold><CText.ucltandcItSm>by</CText.ucltandcItSm> MAX</CText.ucltandcBold>
            </CView>
        </TouchableOpacity>
    );

}

const textComponents = [
    <CView>
        <CText.ucltandcItSm>Level</CText.ucltandcItSm>
        <CText.ucltandcBold>UP!</CText.ucltandcBold>
    </CView>,
    <CView>
        <CText.ucltandcItSm>Get</CText.ucltandcItSm>
        <CText.ucltandcBold>MAX!</CText.ucltandcBold>
    </CView>
];

const GetMaxAnimatedButton = ({ onPress, isOpted = false }) => {
    const [currentTextIndex, setCurrentTextIndex] = useState(0);
    const animatedValue = new Animated.Value(0);
    const styles = useStyles()

    const onPressButton = () => {
        if (typeof onPress !== "undefined") {
            onPress();
        }
    }

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentTextIndex((prevIndex) => (prevIndex === textComponents.length - 1 ? 0 : prevIndex + 1));
            animateText();
        }, 2000); // 2 seconds

        return () => clearInterval(interval);
    }, []);

    const animateText = () => {
        animatedValue.setValue(0);
        Animated.timing(animatedValue, {
            toValue: 1,
            duration: 2000, // 1 second
            useNativeDriver: true,
        }).start();
    };

    const translateX = animatedValue.interpolate({
        inputRange: [0, 1],
        outputRange: [1, 0], // Slide in from the left
    });
    
    let maxIconJSX = <CImage.MPShieldSmallIconPNG />;
    let switchTextData = textComponents;
    if (isOpted) {
        switchTextData = textComponentsOpted;
        maxIconJSX = <CImage.MpShieldBlueSmallIconPNG />;
    }

    return (
        <TouchableOpacity style={styles.button} onPress={() => onPressButton()}>
            {maxIconJSX}
            <View style={styles.textContainer}>
                <View style={styles.animatedTextWrapper}>
                    <Animated.View style={[styles.animatedTextContainer, { transform: [{ translateX }] }]}>
                        {switchTextData[currentTextIndex]}
                    </Animated.View>
                </View>
            </View>
        </TouchableOpacity>
    );
};

const useStyles = CreateResponsiveStyle(
    {
        button: {
            flexDirection: 'row',
            alignItems: 'center',
            width: RFValue(50),
            height: RFValue(20),
            paddingVertical: RFValue(5),
            paddingHorizontal: RFValue(4),
            borderColor: '#c7d5e4',
            borderWidth: RFValue(2),
            borderRadius: RFValue(23),
            backgroundImage: "linear-gradient(to right, #fff 0%, #cedae6 100%)",
            marginTop: 10,
            marginRight:5
        },
        textContainer: {
            flex: 1,
            alignItems: 'flex-end',
            width: RFValue(36),
        },
        animatedTextWrapper: {
            width: RFValue(24),
            overflow: 'hidden', // Clip any content outside the button
        },
        animatedTextContainer: {
            flexDirection: 'row',
        },
    },

    {
        [DEVICE_SIZES.LG]: {

        },
        [DEVICE_SIZES.MD]: {
            button: {
                width:90,
                height: 32,
                paddingVertical: 5,
                paddingHorizontal: 6,
                borderColor: '#c7d5e4',
                borderWidth: 2,
                borderRadius: 23,
            },
            textContainer: {
                width: 40,
            },
            animatedTextWrapper: {
                width: 40,
            },

        },
        [DEVICE_SIZES.SM]: {
            button: {
                width:70,
                height: 26,
                paddingVertical: 5,
                paddingHorizontal: 6,
                borderColor: '#c7d5e4',
                borderWidth: 2,
                borderRadius: 23,
            },
            textContainer: {
                width: 35,
            },
            animatedTextWrapper: {
                width: 29,
            },

        },
        [DEVICE_SIZES.XS]: {
            button: {
                width:95,
                height: 30,
                paddingVertical: 4,
                paddingHorizontal: 4,
                borderColor: '#c7d5e4',
                borderWidth: 2,
                borderRadius: 23,
            },
            textContainer: {
                width: 53,
            },
            animatedTextWrapper: {
                width: 50,
            },
        },
    }
);

export default GetMaxAnimatedButton;